import { Component, OnInit, ViewChild,ViewEncapsulation } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LoadService } from '../../services/load.service';
import { TagsService } from '../../services/tags.service';
import { Tags } from '../../model/Tags';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';
import { FilterUrlService } from '../../services/filter-url.service';

@Component({
  selector: 'tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class TagsComponent implements OnInit {
  @ViewChild(ModalDirective) public lgModal: ModalDirective;
  public load:number;
  public primeracarga:boolean;
  public isopen:boolean;
  public alert:string;
  public data_list:any;
  public links: any;
  public meta: any;
  public title:string;
  public isNew:boolean;
  public signupForm:FormGroup;
  public item_to_update:number;
  public etiquetas:any[];
  public prefix:number;
  public borrartodos:boolean;
  public urlconditions:string;
  public showMessage:boolean;
  public message:string;

  public settings = {
    columns:{
      prefix: { header: "Prefijo", type:"text",filter: { visible:true }},
      po_number: { header: "Orden de Producción", type:"text",filter: { visible:true }},
      lot_code: { header: "Lote", type:"text",filter: { visible:true }},
      product_code: { header: "Producto", type:"text",filter: { visible:true }},
      elaboration_date: { header: "Fecha Elaboración", type:"date",filter: { visible:true }},
      expiration_date:{header:"Fecha Vencimiento",type:"date",filter: { visible:true }}
    },
    actions:{
      edit: true,
      view: false,
      delete: false
    }
  };

  constructor(private _localeService: BsLocaleService,private _tagsService:TagsService,private _loaddata: LoadService,private _filter: FilterUrlService) {
    this.urlconditions = '&sort=-prefix';
    this.isopen = false;
    this.alert = "";
    this.primeracarga = false;
    this.etiquetas = [];
    this.prefix = 0;
    this.borrartodos = false;
    this.showMessage = false;
    this.message = '';
  }

  ngOnInit() {
    this._loaddata.loadChange(15);
    this._localeService.use('es');
    this._filter.filterFirstLoad(this.settings);
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.loadData();
  }

  loadDataFiltered(filters){
    this.isopen = true;
    this.alert = 'Cargando listado.';
    this._loaddata.loadChange(60);

    this._tagsService.getDataFiltered(filters).subscribe(
      (response:any) => {
        this.data_list = response.data;
        this.links = response.links;
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta.";
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        if(error.status == 0){
          this.alert = 'Busqueda sin resultados.';
          this.onClosedAutomatic();
        }
        else{
          this.showError(error.error.error);
        }
      }
    );
  }

/**
 * Carga el listado de informacion.
 */
  loadData():void{
    this.data_list = [];
    this.isopen = true;
    this.alert = 'Cargando listado.'
    this._loaddata.loadChange(40);
    this._tagsService.getAllbyPrefix().subscribe(
      (response:any) => {
        this.data_list = response.data;
        //console.log("Data de Etiquetas ", response);
        this.links = response.links;
        this.changeLinks(this.urlconditions);
        this.meta = response.meta;
        this._loaddata.loadChange(100);
        this.alert = "Carga Correcta."
        this.isopen =true;
        this.onClosedAutomatic();
        if(this.primeracarga === false){
          this.primeracarga = !this.primeracarga;
        }
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  changeLinks(conditions:string){
    if(this.links.first != null){
      this.links.first = this.links.first+''+conditions;
    }
    if(this.links.last != null){
      this.links.last = this.links.last+''+conditions;
    }
    if(this.links.next != null){
      this.links.next = this.links.next+''+conditions;
    }
    if(this.links.prev != null){
      this.links.prev = this.links.prev+''+conditions;
    }
  }

/**
 * Envia a la BD los datos a actualizar.
 */
  updateForm():void{
    this.alert = "Ejecutando actualización.";
    this.isopen =true;
    this._loaddata.loadChange(35);
    let htmlbody = this._tagsService.transformData(this.signupForm.value);
    this._tagsService.update(htmlbody).subscribe(
      data => {
        this._loaddata.loadChange(70);
        this.alert = "Elemento actualizado.";
        this.hideChildModal();
        this.loadData();
        this.onClosedAutomatic();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  deleteItem(data):void{
    this.alert = "Cargando información.";
    this.isopen =true;
    this.title = "Eliminar Todas las Etiquetas QR";
    this.isNew = false;
    this.prefix = data.url.attributes.prefix;

    this._tagsService.getTagsFromPrefix(this.prefix).subscribe(
      (response:any) => {
        this.etiquetas = response.data;
        this.borrartodos = true;
        this.alert = "Etiquetas QR cargadas.";
        this._loaddata.loadChange(100);
        this.lgModal.show();
        this.onClosedAutomatic();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  onDeleteAllTags(){
    let id = 0;
    this.isopen = true;
    this.alert = 'Ejecutando eliminación.'
    this._loaddata.loadChange(35);
    let that = this;

    for(let eti of this.etiquetas){
      setTimeout(() => {
        that._tagsService.delete(eti.links.self).subscribe(
          (response:any) => {
            id += 1;
            if(id == that.etiquetas.length){
              if(that.alert == 'Ejecutando eliminación.'){
                that.alert = "Todas las etiquetas han sido eliminadas.";
                that._loaddata.loadChange(100);
                that.lgModal.hide();
                that.loadData();
              }
              else{
                that.alert = " Error al eliminar etiquetas QR. Eliminación incompleta.";
                that._loaddata.loadChange(100);
              }
            }
          },
          (error) => {
            console.log("SIIIII");
            if(error.error.code == 409){
              this.message = error.error.error;
              this.showMessage = true;
            }
            that.alert = error.error.error;
            id += 1;
            if(id == that.etiquetas.length){
              that.alert = " Error al eliminar etiquetas QR. Eliminación incompleta.";
              that._loaddata.loadChange(100);
            }
          }
        );
      }, 100);
    }
    this.onClosedAutomatic();
  }

/**
 * Elimina la fila seleccionada de la BD
 * @param  data id de la fila a eliminar
 */
  deleteItem2(data):void{
    this.isopen = true;
    this.alert = 'Generando peticion.'
    this._loaddata.loadChange(35);
    this._tagsService.delete(data.links.self).subscribe(
      (response:any) => {
          this._loaddata.loadChange(100);
          this.alert = "Etiqueta QR eliminada.";
          this._tagsService.getTagsFromPrefix(this.prefix).subscribe(
            (response:any) => {
              this.etiquetas = response.data;
              this.isopen = true;
              this.onClosedAutomatic();
            },
            (error) => {
              this.showError(error.error.error);
            }
          );
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

/**
 * Carga la información de una fila en el formulario.
 * @param  index Indice de la fila que se carga en el formulario.
 */
 showEditForm(index) {
   this.alert = "Cargando etiquetas QR."
   this.isopen = true;
   this.title = "Eliminar Etiquetas QR";
   this.isNew = false;
   this.item_to_update = index;
   let item = this.data_list[index];
   console.log("ITEM : ",item);
   this.prefix = item.attributes.prefix;
   //console.log("Prefijo : ",this.prefix);

   this._tagsService.getTagsFromPrefix(this.prefix).subscribe(
     (response:any) => {
       console.log("Respuesta: ",response.data);
       this.etiquetas = response.data;
       this.title = 'Editar Grupo de Etiquetas';
       this.borrartodos = true;
       this.alert = "Carga correcta.";
       this._loaddata.loadChange(100);
       this.lgModal.show();
       this.onClosedAutomatic();
     },
     (error) => {
       this.showError(error.error.error);
     }
   );
 }



/**
 * Muestra el modal para crear o actualizar segun corresponda.
 * @param tipo si es crear o actualizar
 */
  showChildModal(tipo:string): void {
    if(tipo === "Crear"){
      this.title = "Crear Etiqueta QR";
      this.isNew = true;
    } else if(tipo === "Actualizar"){
      this.title = "Actualizar Etiqueta QR";
      this.isNew = false;
    }
    this.lgModal.show();
  }

/**
 * Cierra el modal
 */
  hideChildModal(): void {
    this.lgModal.hide();
    this.showMessage = false;
  }

/**
 * Cierra el mensaje de alerta.
 */
  onClosed(): void {
    this.isopen = false;
  }

  /**
  * Cierra el mensaje de alerta despues de 5 segundos
  */
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 5000);

  }

/**
 * Muestra un error
 * @param  msg mensaje del error
 */
 showError(msg:string){
   if(msg == undefined){
     this.alert = 'No tiene permisos para realizar la acción.';
   }
   else{
     this.alert = msg;
   }
   this._loaddata.loadChange(100);
   this.isopen =true;
 }

/**
 * Actualiza el listado por la paginacion
 * @param data nuevo listado o mensaje de error.
 */
  updateData(data:any):void{
    if(data === "Error al cargar listado."){
      this.showError(data);
    }
    else{
      this.data_list = data;
    }
  }

  hideMessage(cerrar:boolean){
    console.log("LLEGÓ",cerrar);
    this.showMessage = cerrar;
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/tags/tags.component.ts